import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=916681cc&"
import script from "./PaperList.js?vue&type=script&lang=js&"
export * from "./PaperList.js?vue&type=script&lang=js&"
import style0 from "./PaperList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports